export default "__VITE_ASSET__a3838e16__"